import * as L from "leaflet";
import "leaflet/dist/leaflet.css";
import 'leaflet.pm'
import 'leaflet.pm/dist/leaflet.pm.css'
import 'leaflet.chinatmsproviders'

//定义地图实例
const newMap = (domId, option) => {
  let map = L.map(domId, option)
  return map
}
//切片图层
const createLayers = (map, url, option) => {
  let newLeayer = L.tileLayer(url, option)
  newLeayer.addTo(map)
  return newLeayer
}
//leaflet.ChineseTmsProviders插件加载地图
const chinaLayers = (map, url, option) => {
  let chinaLeayer = L.tileLayer.chinaProvider(url, option)
  chinaLeayer.addTo(map)
  return chinaLeayer
}

export default {newMap,createLayers,chinaLayers}
